<app-companies-data-table [columns]="columns.value" (modifyColumns)="modifyColumns.emit()" [searchLoader]="loader" [showHeaders]="desktopView"></app-companies-data-table>
<ng-container *ngIf="!desktopView">
    <div class="separator16"></div>
    <app-plus-button *ngIf="canAdd" (plusClicked)="addCompany()"></app-plus-button>
</ng-container>
